module.exports = __webpack_public_path__ + "static/media/Data_insight_mo_1-2.20ad419b.svg";